module.exports = "<div class=\"menu-item\"\r\n     [ngClass]=\"{'menu-item-active': isActiveMenuItem }\">\r\n    <img [src]=\"item.image\" class=\"menu-item-icon\">\r\n    <span class=\"menu-item-text\">{{ item.text.toUpperCase() }}</span>\r\n</div>\r\n<div class=\"menu-item-bottomline\">\r\n\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/menu-item.component.html
// module id = 2136
// module chunks = 1